import {Venue} from "./type/venue";

export const googleMap = (venue: Venue) => `https://www.google.com/maps/search/?api=1&query=${venue.name}+${venue.address}+${venue.city}+${venue.state}+${venue.zip}`.replaceAll(" ", "")
export const appleMap = (venue: Venue) => `https://maps.apple.com/?q=${venue.name}+${venue.address}+${venue.city}+${venue.state}+${venue.zip}`.replaceAll(" ", "")


async function getLocalVenueIdMap() {
    const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];
    let map = {};
    let page = 1;
    let pageSize = 100;
    let more = true;

    while (more) {
        const res = await fetch(
            `${BACKEND_HOST}/venues?pagination[page]=${page}&pagination[pageSize]=${pageSize}&filters[market][$eq]=local`

        )
        .catch(e => console.error(e.message));
        const data = await res.json();
        if (data && data.data && Array.isArray(data.data)) {
            data.data.forEach(venue => {
                map[venue.venueKey] = venue;
            });
            more = data.meta && data.meta.pagination && (data.meta.pagination.page < data.meta.pagination.pageCount);
            page++;
        } else {
            more = false;
        }
    }
    return map;
}

export {getLocalVenueIdMap}